<div class="selection-summary-block">
    <div class="selection-header">
        <div class="selection-text">{{Header}}</div>
        <div class="selection-icon" (click)="OnCloseClick()">
            <div class="icon1"></div>
        </div>
    </div>
    <div class="save-selection-body" *ngIf="isSelectionSummaryClick">
        <div class="save-selection-text">
            Please enter the selection name (max 50 characters)
        </div>
        <div class="save-selection-input">
            <input type="text" placeholder="Selection name.." [(ngModel)]="SaveSelection" maxlength="50" autocomplete="off"
          name="SaveSelection" (keydown)="onKeyDown($event)" />
        </div>
        <div class="save-selection-btn" (click)="onSaveBtnClick()">
            <div class="btn-text">Save</div>
        </div>
    </div>
    <div class="summary-view">
      <div class="summary-view-outer">
        <!-- Compare Across section -->
          <div class="summary-header">Compare Across</div>
          <div class="selection-summary-view-text">
            <div *ngFor="let title of titleSection" class="selection-header-container">
              <span class="selection-key">{{title.key}}:</span>
              <span class="selection-value">{{title.value}}</span>
            </div>
          </div>
        
        <!-- Entry Point section -->
        <ng-container *ngIf="entryPoints.length > 0">
          <div class="summary-header">Entry Point</div>
          <div class="selection-summary-view-text">
            <div *ngFor="let entry of entryPoints" class="selection-header-container">
              <span class="selection-key">{{entry.key}}:</span>
              <span class="selection-value">{{entry.value}}</span>
            </div>
          </div>
        </ng-container>
        
        <!-- Selections section -->
          <div class="summary-header">Selections</div>
          <div class="selection-summary-view-text">
            <div *ngFor="let selection of selections" class="selection-header-container">
              <span class="selection-key">{{selection.key}}:</span>
              <span class="selection-value">{{selection.value}}</span>
            </div>
          </div>
        </div>
        
    </div>
</div>